<div>
    <!--Menu Button with all possile actions - context sensitive on logged in an anonnym users-->
    <!--Stellt nur das Sprach-MatMenu bereit — Submenu des Sprach-Eintrags unten-->
    <nav-language-menu #languageMenu></nav-language-menu>
    <span class="menu-button">
        <button mat-mini-fab [matMenuTriggerFor]="menu" aria-label="Menu" [color]="color">
            <mat-icon>menu</mat-icon>
        </button>
    </span>

    <mat-menu #menu="matMenu">
        <button
            *ngIf="showGoToResponses && pollService.pollIsLoaded() && this.headerService.headerClass.showParticipants "
            mat-menu-item routerLink="{{navigationService.getPathPollMatrix()}}">
            <mat-icon>bar_chart</mat-icon>
            <span>{{ 'responseMatrix' | transMigrated | async}}</span>
        </button>
        <button mat-menu-item
            *ngIf="showGoToVote && pollService.pollIsLoaded()  && this.headerService.headerClass.showParticipants"
            routerLink="{{navigationService.getPathVote()}}">
            <mat-icon>checklist</mat-icon>
            <span>{{ 'vote' | transMigrated | async}}</span>
        </button>
        <button mat-menu-item (click)="navigateToChoosePollTemplate()"
            [disabled]="routeContextService.id === 'createPoll' || routeContextService.id === 'choosePollTemplate'">
            <mat-icon>add_circle</mat-icon>
            <span>{{ 'create' | transMigrated | async}}</span>
        </button>
        <button *ngIf="authService.isLoggedIn" mat-menu-item routerLink="{{trans.getRoutePath('myPolls')}}">
            <mat-icon>view_list</mat-icon>
            <span>{{ 'my-events' | transMigrated | async}}</span>
        </button>
        <button *ngIf="authService.isLoggedIn && !authService.isAnonymous" mat-menu-item
            routerLink="{{trans.getRoutePath('userProfile')}}">
            <mat-icon>settings</mat-icon>
            <span>{{ 'my-profile' | transMigrated | async}}</span>
        </button>

        <button mat-menu-item routerLink="{{trans.getRoutePath('feedback')}}">
            <mat-icon>add_comment</mat-icon>
            <span>{{ 'contact' | transMigrated | async}}</span>
        </button>
        <!--Label-Teil inkl. Doppelpunkt aus dem Dic (FR: schmales geschuetztes Leerzeichen vor dem Doppelpunkt)-->
        <button mat-menu-item [matMenuTriggerFor]="languageMenu.menu">
            <mat-icon>language</mat-icon>
            <span>{{ trans.translate('language.menuTrigger') }} {{ languageMenu.currentLanguageName }}</span>
        </button>

        <!--no "Personal Access Link" entry here: without a poll context there is no link in phase 1
            (concept-poll-scoped-access §0 decision 4); the key icon of the context bar covers the poll pages-->
        <button *ngIf="authService.isLoggedIn  && authService.isAnonymous" mat-menu-item
            routerLink="{{trans.getRoutePath('upgradeAnonymous')}}">
            <mat-icon>person_add</mat-icon>
            <span>{{ 'sign-up' | transMigrated | async}}</span>
        </button>

        <button *ngIf="!authService.isLoggedIn" mat-menu-item routerLink="{{trans.getRoutePath('userLogin')}}">
            <mat-icon>login</mat-icon>
            <span>{{ 'login' | transMigrated | async}}</span>
        </button>
        <button *ngIf="!authService.isLoggedIn" mat-menu-item routerLink="/user/signup">
            <mat-icon>person_add</mat-icon>
            <span>{{ 'sign-up' | transMigrated | async}}</span>
        </button>
        <button *ngIf="authService.isLoggedIn" mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>{{ 'log-out' | transMigrated | async}}</span>
        </button>
    </mat-menu>
</div>
